import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

const SplashScreen = ({
  className,
  showInitialAnimation = true,
  message,
}: {
  className?: string;
  showInitialAnimation?: boolean;
  message?: string;
}) => {
  return (
    <div
      className={cn(
        "fixed inset-0 flex flex-col gap-4 items-center justify-center bg-background z-50",
        className
      )}
    >
      <motion.div
        initial={
          showInitialAnimation
            ? { opacity: 0, scale: 0.4 }
            : { opacity: 1, scale: 0.8 }
        }
        animate={{ opacity: 1, scale: 0.8 }}
        transition={showInitialAnimation ? { duration: 0.6 } : { duration: 0 }}
        className="rounded-2xl overflow-hidden relative group z-20"
      >
        <img
          src="/id-logo-sq.png"
          alt="about-intro-1"
          height={150}
          width={150}
          className="object-cover"
        />

        <motion.img
          animate={{
            x: "100%",
            transition: {
              duration: 0.8,
              repeat: Infinity,
              repeatDelay: 3,
              delay: 1,
            },
          }}
          initial={{ x: "-100%" }}
          src="/shine.png"
          alt="about-intro-1"
          className="object-cover absolute inset-0 w-full h-full"
        />
      </motion.div>
      <motion.p
        initial={
          showInitialAnimation ? { opacity: 0, y: 10 } : { opacity: 1, y: 0 }
        }
        animate={{ opacity: 1, y: 0 }}
        transition={
          showInitialAnimation
            ? { duration: 0.5, delay: 1 }
            : { duration: 0, delay: 0 }
        }
        className="text-center text-base font-medium text-foreground"
      >
        {message || "Hang tight, we're setting things up!"}
      </motion.p>
    </div>
  );
};

export default SplashScreen;
